import React, { useState, useEffect, useRef } from "react";

import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { GENERATE_QRCODE, GET_CARD_INFO, GET_STAKEHOLDER_PHOTO, DOWNLOAD_DOCUMENT, authKey } from '../../../common/URLs';
import logo from '../../../images/logo.png';
import abeplLogo from "../../../images/abeplLogo.png";
import Divider from '@mui/material/Divider';
import './printCard.css';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { loaderService } from "../../../common/custom-loader/loader-service";
import apiClient from "../../../axios";
// import { PROD } from "../../../common/constants";

export const PrintCard = React.forwardRef((props, ref) => {
    const [cardInfo, setCardInfo] = useState();
    const [blobUrl, setBlobUrl] = useState();
    const [profilePhoto, setProfilePhoto] = useState();
    const [displayImage, setDisplayImage] = useState();

    useEffect(() => {
        if (props.urn) {
            getCardInfo();
            getQRCode();
            getStakeholderPhoto();
        }
    }, [props.urn]);
    // useEffect(() => {
    //     getQRCode();
    // }, [props.urn]);
    // useEffect(() => {
    //     getStakeholderPhoto();
    // }, [props.urn]);

    useEffect(() => {
        if (profilePhoto) {
            downloadDocument(profilePhoto?.documentBlobName, profilePhoto?.documentName, null);
        }
    }, [profilePhoto])

    function getCardInfo() {
        apiClient
            .post(GET_CARD_INFO,
                {
                    "urn": props.urn,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setCardInfo(response.data.cardInfo);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function getQRCode() {
        return fetch(GENERATE_QRCODE,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "qrCodeData": props.urn,
                })
            })
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                setBlobUrl(window.URL.createObjectURL(blob));
            });
    }

    function getStakeholderPhoto() {
        apiClient
            .post(GET_STAKEHOLDER_PHOTO,
                {
                    "urn": props.urn,
                    "type": " ",
                    "includeRejected": true,
                    "isScrutinyView": true

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setProfilePhoto(response.data.document);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const downloadDocument = (blobFileName, finalfileName, callback) => {
        loaderService.showLoader()
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": blobFileName,
                    "containerName": "stakeholder",
                    "file": ""
                })
            })
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                const fileName = finalfileName
                const splittedName = fileName.split('.')
                const fileExtension = splittedName[splittedName.length - 1];
                let fileType;
                switch (fileExtension) {
                    case 'pdf':
                        fileType = 'application/pdf';
                        break;
                    case 'png':
                        fileType = 'image/png';
                        break;
                    case 'jpg':
                        fileType = 'image/jpeg';
                        break;
                    case 'jpeg':
                        fileType = 'image/jpeg';
                        break;
                    default:
                        fileType = 'application/octet-stream';
                }
                const x = new Blob([blob], { type: fileType });
                const url = URL.createObjectURL(x);
                setDisplayImage(url);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });

    }

    return (
        <div ref={ref} className="div_card_container">
            <Container fluid>
                <Row className="title_bg">
                    {/* {!PROD &&  <p style={{textAlign:"center", fontSize:"2vh"}}>REG60</p>} */}

                    {/* <Col xs={12} md={12}>
                        <Stack direction="horizontal" >
                            <div>
                                <img className="logo-image" src={sidebarLogo} alt="blogo" />
                            </div>
                            <div className="card_title">Assam Bio Ethanol Private Limited
                                NUMALIGARH, ASSAM
                            </div>
                        </Stack>
                        
                      
                    </Col> */}
                    <Col xs={2} md={2}>

                        <div>
                            <img className="logo-image" src={abeplLogo} alt="blogo" />
                        </div>

                    </Col>
                    <Col xs={9} md={9}>
                        <div className="card_title">Assam Bio Ethanol Private Limited
                            <div className="below_title">NUMALIGARH, ASSAM</div>
                        </div>
                    </Col>
                    <Col xs={2} md={2}></Col>
                </Row>
                <Row>
                    <div className="card_second_title">STAKEHOLDER REGISTRATION CARD</div>
                </Row>
                <Row className="body_bg">
                    <Row className="urn_label_card">
                        <div className="urn_label_style">Unique Registration Number (URN)<div className="urn_no_style">{cardInfo?.urn} </div></div>
                    </Row>
                    <Col xs={2} md={2} >
                        <img className="qr-image" src={blobUrl} />
                    </Col>
                    <Col xs={3} md={3}>
                        <div >

                            <Stack direction="verticle">
                                <div className="label_card">Name</div>
                                <div className="label_card">Mobile Number</div>
                                <div className="label_card">Address</div>

                            </Stack>
                        </div>
                    </Col>
                    <Col xs={4} md={4} style={{ marginBottom: "2vh" , marginLeft: 0}}>
                        <div >

                            <Stack direction="verticle">
                                <div className="label_card">{cardInfo?.name}</div>
                                <div className="label_card">{cardInfo?.mobileNumber}</div>
                                <div className="label_card">{cardInfo?.address}</div>

                            </Stack>
                        </div>
                    </Col>
                    <Col xs={3} md={3}>
                        <img className="pp-image" src={displayImage} />
                    </Col>

                </Row>
            </Container>
        </div>
    );
});